import { structureWithSpecificationBasePrompt } from './structureBasePrompt';
export const generateStructurePrompt = structureWithSpecificationBasePrompt.temp(0.5).human('Please, give me a structure of the application.');
//# sourceMappingURL=generateStructurePrompt.js.map